import { loadingModelsSelector, modelsIdsSelector } from '@/redux/models/models.selectors';
import { modelElementsDataSelector } from '@/redux/modelElements/modelElements.selector';
import { store } from '@/redux/store';
import { ModelElement } from 'minerva-plugin-api';

const isReady = (): boolean => {
  const state = store.getState();
  if (loadingModelsSelector(state) !== 'succeeded') return false;
  const modelIds = modelsIdsSelector(state);
  const elementsData = modelElementsDataSelector(state);
  return modelIds.every(
    id => elementsData[id]?.loading === 'succeeded' || elementsData[id]?.loading === 'failed',
  );
};

const waitUntilReady = (): Promise<void> =>
  new Promise(resolve => {
    if (isReady()) {
      resolve();
      return;
    }
    const unsubscribe = store.subscribe(() => {
      if (isReady()) {
        unsubscribe();
        resolve();
      }
    });
  });

export const getAll = async (): Promise<ModelElement[]> => {
  await waitUntilReady();
  const elementsData = modelElementsDataSelector(store.getState());
  return Object.values(elementsData).flatMap(modelState => modelState.data ?? []);
};
